import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainer, ErrorSpan, Form, InputContainer } from "../DepositElements";
import astropayLogo from '../../../assets/images/astropay002.png';
import Rastropay from '../../../assets/images/RETIRACONASTROPAY.svg';

const FormAstroPay = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);

  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>

    <InputContainer>
      <label>{t("deposit.phone")}</label>
      <input
        type="text"
        placeholder={t("deposit.phone")}
        name="numeroTelefono"
        value={form.numeroTelefono}
        onChange={handleChange}
      />
    </InputContainer>

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />
        {monto < 30 && moneda === '$' && blur && (
          <ErrorSpan>{t("global.amount-greater-than")} {moneda}30{" "}</ErrorSpan>
        )}

        {monto > 3000 && moneda === '$' && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {moneda}3.000{" "}
          </ErrorSpan>
        )}

        {monto < 30000 && moneda === 'COP' && blur && (
          <ErrorSpan>{t("deposit.amount-greater-than")} 30.000 {moneda}{" "}</ErrorSpan>
        )}

        {monto > 5000000 && moneda === 'COP' && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {monto < 2000 && moneda === 'ARS' && blur && (
          <ErrorSpan>{t("deposit.amount-greater-than")} 2.000 {moneda}{" "}</ErrorSpan>
        )}

        {monto > 500000 && moneda === 'ARS' && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 900.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {monto < 20000 && moneda === 'CLP' && blur && (
          <ErrorSpan>{t("deposit.amount-greater-than")} 20.000 {moneda}{" "}</ErrorSpan>
        )}

        {monto > 5000000 && moneda === 'CLP' && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

      </InputContainer>
      <img src={Rastropay} alt='astropay' className={'astro1'} style={{width:'43%', marginLeft: '28%', marginTop: '5%', marginBottom:'2%'}}/>
      <img src={astropayLogo} alt='Pasarelas astropay' className={'astro3'} style={{width:'100%', marginTop: '0%', marginLeft: '-2.2%'}}/>

      <ButtonsContainer style={{marginTop:'-90px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button primary={true}
          disabled={loading || (monto < 30 && moneda === '$') || 
          (monto > 3000 && moneda === '$') || (monto < 30000 && moneda === 'COP') || 
          (monto >  5000000 && moneda === 'COP') || (monto <  2000 && moneda === 'ARS') ||
          (monto >  500000 && moneda === 'ARS') || (monto <  20000 && moneda === 'CLP') || 
          (monto >  5000000 && moneda === 'CLP')}
          onClick={solicitarRetiro}>
          {loading ?  t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormAstroPay;
